import React, { useContext, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import './CreateJob.css';
// import { getJobList, addEditJob } from './Service/RecruitmentService';
import { GetMasterTypeData } from '../../../../Services/Global-Services/GlobalServices';
import ERROR_LIST from '../../../../Services/Global-Services/Hadle_Errors';
import { TostMsg } from '../../../../App';
import { getJobList, postJobSave } from './Service/RecruitmentService';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
 
const CreateJob = () => {
  const { Id } = useParams();              // undefined on /Create, a value on /Edit/:Id
  const jobId = Number(Id) || 0;
  const isEdit = jobId > 0;
  const history = useHistory();
  const toster = useContext(TostMsg);
 
  const emptyForm = {
    Id: 0,
    TalentRequestId: 0,
    Title: '',
    DepartmentId: '',
    JobStatusId: '',
    VisibilityId: '',
    EmploymentTypeId: '',
    WorkModeId: '',
    Location: '',
    NoticePeriodDays: '',
    SalaryCurrencyCode: 'INR',
    IsSalaryNegotiable: false,
    NumberOfOpenings: 1,
    JobDescription: '',
    RecruiterEmpId: '',
    ExperienceRangeId: '',
    SalaryRangeId: '',
    FeedbackAspects: '',
  };
 
  const [form, setForm] = useState(emptyForm);
  const [mustSkills, setMustSkills] = useState([]);
  const [prefSkills, setPrefSkills] = useState([]);
  const [mustBullets, setMustBullets] = useState(['']);
  const [prefBullets, setPrefBullets] = useState(['']);
  const [publishStatus, setPublishStatus] = useState('draft');
 
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
 
  // master data
  const [departments, setDepartments] = useState([]);
  const [jobStatusList, setJobStatusList] = useState([]);
  const [visibilityList, setVisibilityList] = useState([]);
  const [employmentTypeList, setEmploymentTypeList] = useState([]);
  const [workModeList, setWorkModeList] = useState([]);
  const [experienceRangeList, setExperienceRangeList] = useState([]);
  const [salaryRangeList, setSalaryRangeList] = useState([]);
  const [recruiterList, setRecruiterList] = useState([]);
 
  const setField = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));
 
 
 
 
  const [activeSection, setActiveSection] = useState('s-basic');
 
  const userDetails = JSON.parse(localStorage.getItem('User') || '{}');
 
  const loadMaster = async (masterType, setter) => {
    try {
      const response = await GetMasterTypeData({ masterType, allRecords: true, organisationId: userDetails?.OrgId });
      setter(response?.Data || []);
    } catch (error) {
      toster?.current?.error('Failed to load ' + masterType, 'error');
    }
  };
 
  useEffect(() => {
    loadMaster('Department', setDepartments);
    loadMaster('JobStatus', setJobStatusList);
    loadMaster('Visibility', setVisibilityList);
    loadMaster('EmploymentType', setEmploymentTypeList);
    loadMaster('WorkMode', setWorkModeList);
    loadMaster('ExperienceRange', setExperienceRangeList);
    loadMaster('SalaryRange', setSalaryRangeList);
    loadMaster('Recruiter', setRecruiterList); // adjust masterType name if recruiters come from a different source
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 
  const fetchJobForEdit = async () => {
    if (!isEdit) return;
    setLoading(true);
    try {
      const params = {
        JobId: jobId,
        Guid: '',
        TalentRequestId: 0,
        RecruiterEmpId: 0,
        JobStatusId: '',
        VisibilityId: '',
        EmploymentTypeId: '',
        WorkModeId: '',
        DepartmentId: '',
        Location: '',
        Search: '',
        PageNumber: 1,
        PageSize: 1,
        CreatedFrom: '',
        CreatedTo: '',
        SortBy: '',
        SortOrder: 'ASC',
        ExperienceRangeId: '',
        SalaryRangeId: '',
        ExperienceMin: '',
        ExperienceMax: '',
      };
 
      const response = await getJobList(params);
      const job = response?.Data?.Jobs?.[0];
 
      if (!job) {
        toster?.current?.error('Job not found');
        return;
      }
 
      setForm({
        Id: job.Id || 0,
        TalentRequestId: job.TalentRequestId || 0,
        Title: job.Title || '',
        DepartmentId: job.DepartmentId ?? '',
        JobStatusId: job.JobStatusId ?? '',
        VisibilityId: job.VisibilityId ?? '',
        EmploymentTypeId: job.EmploymentTypeId ?? '',
        WorkModeId: job.WorkModeId ?? '',
        Location: job.Location || '',
        NoticePeriodDays: job.NoticePeriodDays ?? '',
        SalaryCurrencyCode: job.SalaryCurrencyCode || 'INR',
        IsSalaryNegotiable: !!job.IsSalaryNegotiable,
        NumberOfOpenings: job.NumberOfOpenings ?? 1,
        JobDescription: job.JobDescription || '',
        RecruiterEmpId: job.RecruiterEmpId ?? '',
        ExperienceRangeId: job.ExperienceRangeId ?? '',
        SalaryRangeId: job.SalaryRangeId ?? '',
        FeedbackAspects: job.FeedbackAspects || '',
      });
 
      setMustSkills(job.SkillsMust ? job.SkillsMust.split(',').map((s) => s.trim()).filter(Boolean) : []);
      setPrefSkills(job.SkillsPref ? job.SkillsPref.split(',').map((s) => s.trim()).filter(Boolean) : []);
      setMustBullets(job.RequirementsMust ? job.RequirementsMust.split('\n').filter(Boolean) : ['']);
      setPrefBullets(job.RequirementsPref ? job.RequirementsPref.split('\n').filter(Boolean) : ['']);
      setPublishStatus(statusIsDraft(job.JobStatusId) ? 'draft' : 'active');
    } catch (error) {
      toster?.current?.error(ERROR_LIST?.TalentRequestList || 'Failed to load job');
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    fetchJobForEdit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);
 
  const statusIsDraft = (id) => {
    const found = jobStatusList.find((s) => s.Id === id);
    return found ? found.Name?.toLowerCase().includes('draft') : true;
  };
 
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setActiveSection(id);
  };
 
  const addTag = (e, type) => {
    if (e.key !== 'Enter' || !e.target.value.trim()) return;
    e.preventDefault();
    const val = e.target.value.trim();
    if (type === 'must') setMustSkills((prev) => [...prev, val]);
    else setPrefSkills((prev) => [...prev, val]);
    e.target.value = '';
  };
 
  const removeTag = (index, type) => {
    if (type === 'must') setMustSkills((prev) => prev.filter((_, i) => i !== index));
    else setPrefSkills((prev) => prev.filter((_, i) => i !== index));
  };
 
  const addBullet = (type) => {
    if (type === 'must') setMustBullets((prev) => [...prev, '']);
    else setPrefBullets((prev) => [...prev, '']);
  };
 
  const updateBullet = (type, index, value) => {
    const setter = type === 'must' ? setMustBullets : setPrefBullets;
    setter((prev) => prev.map((b, i) => (i === index ? value : b)));
  };
 
  const removeBullet = (type, index) => {
    const setter = type === 'must' ? setMustBullets : setPrefBullets;
    setter((prev) => prev.filter((_, i) => i !== index));
  };
 
  const findDraftStatusId = () => jobStatusList.find((s) => s.Name?.toLowerCase().includes('draft'))?.Id;
  const findOpenStatusId = () => jobStatusList.find((s) => s.Name?.toLowerCase().includes('open'))?.Id;
 
  const validate = () => {
    if (!form.Title.trim()) return 'Job title is required';
    if (!form.DepartmentId) return 'Department is required';
    if (!form.EmploymentTypeId) return 'Employment type is required';
    if (!form.WorkModeId) return 'Work mode is required';
    if (!form.Location.trim()) return 'Location is required';
    return null;
  };
 
  const saveJob = async (mode) => {
    const error = validate();
    if (error) {
      toster?.current?.error(error);
      return;
    }
    const jobStatusId =
      mode === 'draft' ? findDraftStatusId() : findOpenStatusId();
 
    const payload = {
      Id: isEdit ? jobId : 0,
      TalentRequestId: Number(form.TalentRequestId) || 0,
      Title: form.Title,
      DepartmentId: Number(form.DepartmentId),
      JobStatusId: Number(jobStatusId) || 0,
      VisibilityId: Number(form.VisibilityId) || 0,
      EmploymentTypeId: Number(form.EmploymentTypeId),
      WorkModeId: Number(form.WorkModeId),
      Location: form.Location,
      NoticePeriodDays: Number(form.NoticePeriodDays) || 0,
      SalaryCurrencyCode: form.SalaryCurrencyCode || 'INR',
      IsSalaryNegotiable: !!form.IsSalaryNegotiable,
      NumberOfOpenings: Number(form.NumberOfOpenings) || 1,
      JobDescription: form.JobDescription,
      RecruiterEmpId: Number(form.RecruiterEmpId) || 0,
      RequirementsMust: mustBullets.filter(Boolean).join('\n'),
      RequirementsPref: prefBullets.filter(Boolean).join('\n'),
      SkillsMust: mustSkills.join(','),
      SkillsPref: prefSkills.join(','),
      FeedbackAspects: form.FeedbackAspects || '',
      ExperienceRangeId: Number(form.ExperienceRangeId) || 0,
      SalaryRangeId: Number(form.SalaryRangeId) || 0,
    };
 
    setSubmitting(true);
    try {
      const response = await postJobSave(payload);
      toster?.current?.success(
        isEdit
          ? `Job updated — ${response?.Data?.JobCode || ''}`
          : mode === 'draft'
            ? `Job saved as Draft — ${response?.Data?.JobCode || ''}`
            : `Job created and published — ${response?.Data?.JobCode || ''}`
      );
      setTimeout(() => history.push('/Recruitment/JobsPage'), 1200);
    } catch (err) {
      toster?.current?.error(ERROR_LIST?.TalentRequestList || 'Failed to save job');
    } finally {
      setSubmitting(false);
    }
  }
 
  return (
    <>
     
        <div className="topbar">
          <i className="fa-solid fa-briefcase" ></i>
          <div className="breadcrumb topbar-breadcrumb" >
            <a>Recruitment</a>
            <i className="fa-solid fa-chevron-right" ></i>
            <a>Jobs</a>
            <i className="fa-solid fa-chevron-right" ></i>
            <strong className="topbar-current">Create Job</strong>
          </div>
          <div className="top-right">
         
          <div className="top-user">
           
            <div className="top-avatar">AM</div>
            <div>
             
              <div className="top-user-name"> Arun Mishra </div>
              <div className="top-user-role"> HR Admin </div>
            </div>
          </div>
        </div>
        </div>
      <div className="container-fluid position-relation">
 
       
          <div className="page-hd">
              <div className='Page-head'>
                   <div className='leftside-head'>
              <h2>
                <i className="fa-solid fa-plus-circle"></i>
                Create Job
              </h2>
              <div className="breadcrumb">Fill in job details, requirements and visibility settings</div>
            </div>
           <Link to="/Recruitment/JobsPage" className="btn btn-outline btn-sm btn-gray" >
              <i className="fa-solid fa-arrow-left"></i> Back
            </Link>
          </div>
        </div>
 
        <div className="form-layout">
          {/* Navigation */}
          <div className="form-nav">
            {[
              { id: 's-basic', icon: 'fa-circle-info', label: 'Basic Info' },
              { id: 's-details', icon: 'fa-sliders', label: 'Job Details' },
              { id: 's-comp', icon: 'fa-indian-rupee-sign', label: 'Compensation' },
              { id: 's-must', icon: 'fa-star', label: 'Must Have' },
              { id: 's-pref', icon: 'fa-thumbs-up', label: 'Preferred' },
              { id: 's-jd', icon: 'fa-file-lines', label: 'Job Description' },
              { id: 's-vis', icon: 'fa-eye', label: 'Visibility' },
            ].map(item => (
              <div
                key={item.id}
                className={`fn-item ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => scrollTo(item.id)}
              >
                <i className={`fa-solid ${item.icon}`}></i> {item.label}
              </div>
            ))}
          </div>
 
          {/* Form Sections */}
          <div className="form-sections">
 
            <div className="job-id-preview">
              <i className="fa-solid fa-hashtag"></i>
              <strong>JOB-2026-007</strong>
              <span>Auto-generated · read-only</span>
            </div>
 
 
            {/* SECTION 1 - Basic Info */}
            <div className="fs-bx" id="s-basic">
 
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-circle-info"></i>
                <h4>Basic Information</h4>
              </div>
 
              <div className="fs-body">
 
                <div className="form-row form-row-1">
                  <div className="fg">
                    <label>
                      Job Title <span className="req">*</span>
                    </label>
 
                    <input
                      className="og-input"
                      placeholder="e.g. Senior Product Designer"
                      id="jobTitle"
 
                    />
                  </div>
                </div>
 
                <div className="form-row form-row-2">
 
                  <div className="fg">
                    <label>
                      Department <span className="req">*</span>
                    </label>
 
                    <select className="og-select">
                      <option value="">Select department</option>
                      <option>Engineering</option>
                      <option>Product</option>
                      <option>Design</option>
                      <option>HR</option>
                      <option>Analytics</option>
                      <option>Marketing</option>
                      <option>Finance</option>
                      <option>Operations</option>
                    </select>
                  </div>
 
                  <div className="fg">
                    <label>
                      Number of Openings <span className="req">*</span>
                    </label>
 
                    <input
                      className="og-input"
                      type="number"
                      min="1"
                      defaultValue="1"
                      placeholder="1"
                    />
                  </div>
 
                </div>
 
                <div className="form-row form-row-1">
                  <div className="fg">
                    <label>
                      Link to Talent Request <span className="opt">(optional)</span>
                    </label>
 
                    <select className="og-select">
                      <option value="">None — standalone job</option>
                      <option>
                        TR-2026-012 · Product Manager · 2 openings · Approved
                      </option>
                      <option>
                        TR-2026-015 · Backend Developer · 3 openings · Approved
                      </option>
                      <option>
                        TR-2026-018 · Data Analyst · 1 opening · Approved
                      </option>
                    </select>
                  </div>
                </div>
 
              </div>
            </div>
 
 
            {/* SECTION 2 - Job Details */}
            <div className="fs-bx" id="s-details">
 
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-sliders"></i>
                <h4>Job Details</h4>
              </div>
 
              <div className="fs-body">
 
                <div className="form-row form-row-3">
 
                  <div className="fg">
                    <label>
                      Employment Type <span className="req">*</span>
                    </label>
 
                    <select className="og-select">
                      <option value="">Select…</option>
                      <option>Full-time</option>
                      <option>Part-time</option>
                      <option>Contract</option>
                      <option>Internship</option>
                      <option>Freelance</option>
                    </select>
                  </div>
 
                  <div className="fg">
                    <label>
                      Work Mode <span className="req">*</span>
                    </label>
 
                    <select className="og-select">
                      <option value="">Select…</option>
                      <option>On-site</option>
                      <option>Remote</option>
                      <option>Hybrid</option>
                    </select>
                  </div>
 
                  <div className="fg">
                    <label>
                      Location <span className="req">*</span>
                    </label>
 
                    <input
                      className="og-input"
                      placeholder="City or Remote"
                    />
                  </div>
 
                </div>
 
                <div className="form-row form-row-2">
 
                  <div className="fg">
                    <label>
                      Experience Range <span className="req">*</span>
                    </label>
 
                    <div className="input-group">
 
                      <input
                        className="og-input experience-input"
                        type="number"
                        min="0"
                        placeholder="Min"
                      />
 
                      <span className="input-sep">to</span>
 
                      <input
                        className="og-input experience-input"
                        type="number"
                        min="0"
                        placeholder="Max"
                      />
 
                      <span className="input-sep input-sep-years">
                        yrs
                      </span>
 
                    </div>
                  </div>
 
                  <div className="fg">
                    <label>Notice Period</label>
 
                    <select className="og-select">
                      <option>Immediate</option>
                      <option>15 days</option>
                      <option>30 days</option>
                      <option>45 days</option>
                      <option>60 days</option>
                      <option>90 days</option>
                      <option>Negotiable</option>
                    </select>
                  </div>
 
                </div>
 
              </div>
            </div>
 
 
            {/* SECTION 3 - Compensation */}
            <div className="fs-bx" id="s-comp">
 
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-indian-rupee-sign"></i>
                <h4>Compensation</h4>
              </div>
 
              <div className="fs-body">
 
                <div className="form-row form-row-2">
 
                  <div className="fg">
                    <label>Salary — Minimum</label>
 
                    <div className="input-group">
 
                      <select className="og-select salary-unit">
                        <option>₹ LPA</option>
                        <option>₹ PM</option>
                        <option>$ USD</option>
                      </select>
 
                      <input
                        className="og-input"
                        type="number"
                        placeholder="e.g. 12"
                      />
 
                    </div>
                  </div>
 
                  <div className="fg">
                    <label>Salary — Maximum</label>
 
                    <div className="input-group">
 
                      <select className="og-select salary-unit">
                        <option>₹ LPA</option>
                        <option>₹ PM</option>
                        <option>$ USD</option>
                      </select>
 
                      <input
                        className="og-input"
                        type="number"
                        placeholder="e.g. 18"
                      />
 
                    </div>
                  </div>
 
                </div>
 
                <label className="negotiable-label">
                  <input type="checkbox" />
                  Mark as negotiable — exact range hidden from candidates
                </label>
 
              </div>
            </div>
 
 
            {/* SECTION 4 - Must Have */}
            <div className="fs-bx" id="s-must">
 
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-star"></i>
                <h4>Must Have Requirements</h4>
 
                <span className="fs-subtitle">
                  Non-negotiable qualifications
                </span>
              </div>
 
              <div className="fs-body">
 
                <div className="form-row form-row-1">
 
                  <div className="fg">
 
                    <label>
                      Required Skills <span className="req">*</span>
                    </label>
 
                    <div
                      className="tag-input-wrap"
                      onClick={() => document.getElementById('mustSkillInput').focus()}
                    >
                      {mustSkills.map((skill, idx) => (
                        <span className="tag-item must" key={`${skill}-${idx}`}>
                          {skill}
                          <button type="button" onClick={() => removeTag(idx, 'must')}>×</button>
                        </span>
                      ))}
 
                      <input
                        id="mustSkillInput"
                        className="tag-text-input"
                        placeholder="Type and press Enter…"
                        onKeyDown={(e) => addTag(e, 'must')}
                      />
                    </div>
                    {/* <div
                      className="tag-input-wrap"
                      onClick={() =>
                        document.getElementById("mustSkillInput").focus()
                      }
                    >
 
                      <span className="tag-item must">
                        React
                        <button onClick={(e) => removeTag(e.currentTarget)}>
                          ×
                        </button>
                      </span>
 
                      <span className="tag-item must">
                        TypeScript
                        <button onClick={(e) => removeTag(e.currentTarget)}>
                          ×
                        </button>
                      </span>
 
                      <span className="tag-item must">
                        3+ yrs experience
                        <button onClick={(e) => removeTag(e.currentTarget)}>
                          ×
                        </button>
                      </span>
 
                      <input
                        id="mustSkillInput"
                        className="tag-text-input"
                        placeholder="Type and press Enter…"
                        onKeyDown={(e) => addTag(e, "must")}
                      />
 
                    </div> */}
                  </div>
                </div>
 
 
                <div className="form-row form-row-1">
 
                  <div className="fg">
 
                    <label>
                      Must-have criteria{" "}
                      <span className="opt">
                        — bullet points shown in job posting
                      </span>
                    </label>
 
                    <ul className="bullet-list" id="mustList">
 
                      <li className="bullet-item">
                        <span className="bullet-num">1</span>
 
                        <input
                          className="bullet-input"
                          defaultValue="Bachelor's degree in Computer Science or related field"
                        />
 
                        <button
                          className="bullet-remove"
                          onClick={(e) => removeBullet(e.currentTarget)}
                        >
                          <i className="fa-solid fa-times bullet-remove-icon"></i>
                        </button>
                      </li>
 
                      <li className="bullet-item">
                        <span className="bullet-num">2</span>
 
                        <input
                          className="bullet-input"
                          defaultValue="Minimum 3 years of production React experience"
                        />
 
                        <button
                          className="bullet-remove"
                          onClick={(e) => removeBullet(e.currentTarget)}
                        >
                          <i className="fa-solid fa-times bullet-remove-icon"></i>
                        </button>
                      </li>
 
                      <li className="bullet-item">
                        <span className="bullet-num">3</span>
 
                        <input
                          className="bullet-input"
                          defaultValue="Strong TypeScript and modern JavaScript (ES6+)"
                        />
 
                        <button
                          className="bullet-remove"
                          onClick={(e) => removeBullet(e.currentTarget)}
                        >
                          <i className="fa-solid fa-times bullet-remove-icon"></i>
                        </button>
                      </li>
 
                    </ul>
 
                    <button
                      className="add-bullet-btn"
                      onClick={() => addBullet("mustList")}
                    >
                      <i className="fa-solid fa-plus bullet-remove-icon"></i>
                      Add criterion
                    </button>
 
                  </div>
                </div>
 
              </div>
            </div>
 
 
            {/* SECTION 5 - Preferred */}
            <div className="fs-bx" id="s-pref">
 
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-thumbs-up"></i>
                <h4>Preferred Requirements</h4>
 
                <span className="fs-subtitle">
                  Nice-to-have qualifications
                </span>
              </div>
 
              <div className="fs-body">
 
                <div className="form-row form-row-1">
 
                  <div className="fg">
 
                    <label>
                      Preferred Skills{" "}
                      <span className="opt">(nice to have)</span>
                    </label>
 
                    <div
                      className="tag-input-wrap"
                      onClick={() =>
                        document.getElementById("prefSkillInput").focus()
                      }
                    >
 
                      <span className="tag-item pref">
                        Next.js
                        <button onClick={(e) => removeTag(e.currentTarget)}>
                          ×
                        </button>
                      </span>
 
                      <span className="tag-item pref">
                        GraphQL
                        <button onClick={(e) => removeTag(e.currentTarget)}>
                          ×
                        </button>
                      </span>
 
                      <span className="tag-item pref">
                        CI/CD
                        <button onClick={(e) => removeTag(e.currentTarget)}>
                          ×
                        </button>
                      </span>
 
                      <input
                        id="prefSkillInput"
                        className="tag-text-input"
                        placeholder="Type and press Enter…"
                        onKeyDown={(e) => addTag(e, "pref")}
                      />
 
                    </div>
                  </div>
                </div>
 
 
                <div className="form-row form-row-1">
 
                  <div className="fg">
 
                    <label>
                      Preferred criteria{" "}
                      <span className="opt">
                        — bonus qualifications
                      </span>
                    </label>
 
                    <ul className="bullet-list" id="prefList">
 
                      <li className="bullet-item">
 
                        <span className="bullet-num bullet-num-green">
                          1
                        </span>
 
                        <input
                          className="bullet-input"
                          defaultValue="Experience with design systems and component libraries"
                        />
 
                        <button
                          className="bullet-remove"
                          onClick={(e) => removeBullet(e.currentTarget)}
                        >
                          <i className="fa-solid fa-times bullet-remove-icon"></i>
                        </button>
 
                      </li>
 
                      <li className="bullet-item">
 
                        <span className="bullet-num bullet-num-green">
                          2
                        </span>
 
                        <input
                          className="bullet-input"
                          defaultValue="Open source contributions or personal projects on GitHub"
                        />
 
                        <button
                          className="bullet-remove"
                          onClick={(e) => removeBullet(e.currentTarget)}
                        >
                          <i className="fa-solid fa-times bullet-remove-icon"></i>
                        </button>
 
                      </li>
 
                    </ul>
 
                    <button
                      className="add-bullet-btn add-bullet-green"
                      onClick={() => addBullet("prefList", "green")}
                    >
                      <i className="fa-solid fa-plus bullet-remove-icon"></i>
                      Add criterion
                    </button>
 
                  </div>
                </div>
 
              </div>
            </div>
 
 
            {/* SECTION 6 - Job Description */}
            <div className="fs-bx" id="s-jd">
 
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-file-lines"></i>
                <h4>Job Description</h4>
              </div>
 
              <div className="fs-body">
 
                <div className="editor-toolbar">
 
                  <button
                    className="btn-ghost btn-sm"
 
                    title="Bold"
                  >
                    <i className="fa-solid fa-bold"></i>
                  </button>
 
                  <button
                    className="btn-ghost btn-sm"
 
                    title="Italic"
                  >
                    <i className="fa-solid fa-italic"></i>
                  </button>
 
                  <button
                    className="btn-ghost btn-sm"
 
                    title="Bullet list"
                  >
                    <i className="fa-solid fa-list-ul"></i>
                  </button>
 
                  <button
                    className="btn-ghost btn-sm"
 
                    title="Numbered list"
                  >
                    <i className="fa-solid fa-list-ol"></i>
                  </button>
 
                  <span className="toolbar-divider"></span>
 
                  <button
                    className="btn-ghost btn-sm"
                    title="Link"
                  >
                    <i className="fa-solid fa-link"></i>
                  </button>
 
                  <button
                    className="btn-ghost btn-sm"
                    title="Heading"
                  >
                    <i className="fa-solid fa-heading"></i>
                  </button>
 
                </div>
 
                <textarea
                  className="og-textarea"
                  rows="12"
                  id="jobDesc"
                  placeholder={`Describe the role, team context, day-to-day responsibilities, and what success looks like in this position.
 
Example:
We are looking for a Senior Frontend Developer to join our growing engineering team at BizBrolly. You will work closely with designers and backend engineers to build delightful, high-performance user interfaces for OrgGenie, our flagship SaaS product.
 
Responsibilities:
• Build and maintain reusable UI components
• Collaborate with design team on new features
• Participate in code reviews and architectural discussions`}
                ></textarea>
 
                <div className="description-footer">
                  <span className="description-info">
                    Minimum 100 characters recommended
                  </span>
 
                  <span
                    id="charCount"
                    className="char-count"
                  >
                    0 characters
                  </span>
                </div>
 
              </div>
            </div>
 
 
            {/* SECTION 7 - Visibility */}
            <div className="fs-bx" id="s-vis">
 
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-eye"></i>
                <h4>Visibility &amp; Publishing</h4>
              </div>
 
              <div className="fs-body">
 
                <div className="fg visibility-field">
 
                  <label>
                    Who can see this job? <span className="req">*</span>
                  </label>
 
                  <div className="vis-options">
 
                    <div
                      className="vis-opt selected"
 
                    >
                      <input
                        type="radio"
                        name="vis"
                        defaultChecked
                      />
 
                      <div>
                        <div className="vis-opt-label">
                          Internal only
                        </div>
 
                        <div className="vis-opt-sub">
                          Visible to existing employees for internal moves
                        </div>
                      </div>
                    </div>
 
 
                    <div
                      className="vis-opt"
 
                    >
                      <input
                        type="radio"
                        name="vis"
                      />
 
                      <div>
                        <div className="vis-opt-label">
                          External (ATS)
                        </div>
 
                        <div className="vis-opt-sub">
                          Public on ats.orggenie.com for all applicants
                        </div>
                      </div>
                    </div>
 
 
                    <div
                      className="vis-opt"
                    >
                      <input
                        type="radio"
                        name="vis"
                      />
 
                      <div>
                        <div className="vis-opt-label">
                          Both
                        </div>
 
                        <div className="vis-opt-sub">
                          Internal employees + public ATS listing
                        </div>
                      </div>
                    </div>
 
                  </div>
                </div>
 
 
                <div className="form-row form-row-2">
 
                  <div className="fg">
 
                    <label>Assigned Recruiter</label>
 
                    <select className="og-select">
                      <option>Priya Sharma</option>
                      <option>Neha Gupta</option>
                      <option>Arun Mishra</option>
                    </select>
 
                  </div>
 
                  <div className="fg">
 
                    <label>
                      Feedback Aspects{" "}
                      <span className="opt">
                        — used in interviews
                      </span>
                    </label>
 
                    <select
                      className="og-select"
 
                    >
                      <option>Use org default aspects</option>
                      <option>Customise for this job</option>
                    </select>
 
                  </div>
 
                </div>
 
 
                <div
                  id="feedbackNote"
                  className="feedback-note"
                >
                  <i className="fa-solid fa-circle-info"></i>
 
                  You can add or edit feedback aspects after creating the job,
                  from the interview round setup.
                </div>
 
 
                <div className="form-row form-row-1 publish-row">
 
                  <div className="fg">
 
                    <label>Publish status</label>
 
                    <select
                      className="og-select"
                      id="publishStatus"
                    >
                      <option value="draft">
                        Save as Draft — not visible yet
                      </option>
 
                      <option value="active">
                        Publish now — make it live immediately
                      </option>
                    </select>
 
                  </div>
 
                </div>
 
              </div>
            </div>
 
 
            <div className="form-bottom-space"></div>
 
          </div>
        </div>
 
      </div>
 
       {/* Form Footer */}
      <div className="form-footer">
        <button className="btn btn-outline btn-sm" >Discard</button>
 
        <button className="btn btn-outline btn-sm"  disabled={submitting} onClick={() => saveJob('draft')}>
          <i className="fa-regular fa-floppy-disk"></i> Save as Draft
        </button>
        <button className="btn btn-primary btn-sm" disabled={submitting} onClick={() => saveJob('active')}>
          <i className="fa-solid fa-check"></i> {submitting ? 'Saving…' : (isEdit ? 'Update Job' : 'Create & Publish')}
        </button>
      </div>
 
      {/* Modals preserved */}
    </>
  );
};
 
export default CreateJob;